// cspell:disable
import gogomasterImg from '@/static/assets/customer_reviews/pics/fsd/tweet_face_gogomaster2203.jpg';
import jackiechuichuiImg from '@/static/assets/customer_reviews/pics/fsd/tweet_face_jackiechuichui.png';
import mrjonlambImg from '@/static/assets/customer_reviews/pics/fsd/tweet_face_mrjoblamb.jpg';
import tlepovrafaelImg from '@/static/assets/customer_reviews/pics/fsd/tweet_face_tlepovrafael.jpg';
import virani746Img from '@/static/assets/customer_reviews/pics/fsd/tweet_face_virani746.jpg';
import vivekImg from '@/static/assets/customer_reviews/pics/fsd/tweet_face_vivek.jpeg';
import yasirejImg from '@/static/assets/customer_reviews/pics/fsd/tweet_face_yasirej.jpg';
import yogeesh93Img from '@/static/assets/customer_reviews/pics/fsd/tweet_face_yogeesh93.jpeg';
import markstevensonImg from '@/static/assets/customer_reviews/pics/fsd/tweet_face_mark.jpg';
import chxwangImg from '@/static/assets/customer_reviews/pics/fsd/tweet_face_chxwang.png';
import dissidentImg from '@/static/assets/customer_reviews/pics/fsd/tweet_face_dissident.jpg';
import syedImg from '@/static/assets/customer_reviews/pics/fsd/tweet_face_syed.jpeg';
import jinzImg from '@/static/assets/customer_reviews/pics/fsd/tweet_face_jinz.jpg';
import jenniseImg from '@/static/assets/customer_reviews/pics/fsd/tweet_face_jennise.jpg';
import type { Tweet } from '../../components/TweetCard';

export const fsdUsTweets: Tweet[] = [
  {
    name: 'Ejaz Muhammad',
    img: yasirejImg,
    handle: '@ya.sir.ej',
    text: '"They cover all my insurance needs at an amazing rate!"',
  },
  {
    name: 'Tony Rodriguez',
    img: dissidentImg,
    handle: '@dissidentxanthium',
    text: '"It insures my chaos faster than I cause it."',
  },
  {
    name: 'Gaurav Hedge',
    img: gogomasterImg,
    handle: '@gogomaster2203',
    text: '"It\'s cheaper than my daily caffeine addiction."',
  },
  {
    name: 'Jackie Chui',
    img: jackiechuichuiImg,
    handle: '@jackiechuichui',
    text: '"I only pay for what I use."',
  },
  {
    name: 'Syed Tanveer',
    img: syedImg,
    handle: '@SyedTanveer20',
    text: '"It feels built for how people actually live."',
  },
  {
    name: 'Mark Stevenson',
    img: markstevensonImg,
    handle: '@markfstevenson',
    text: '"It pairs perfectly with my Cherry Bomb Tesla!"',
  },
  {
    name: 'Jon Lamb',
    img: mrjonlambImg,
    handle: '@mrjonlamb',
    text: '"The app experience is amazing."',
  },
  {
    name: 'Housel Notary',
    img: jenniseImg,
    handle: '@elevatedandgrounded',
    text: '"Lets us only pay for the things we want and use."',
  },
  {
    name: 'Danish Virani',
    img: virani746Img,
    handle: '@virani746',
    text: '"Streamlined experience and pay per mile model!"',
  },
  // Disabled for now because it's too long
  // {
  //   name: 'Jay Bahel',
  //   img: jaybahelImg,
  //   handle: '@JayBahel',
  //   text: '"I\'m tired of the same old stodgy way of Insurance. There\'s gotta be a better way and Lemonade is that way."',
  // },
  {
    name: 'Chengxuan Wang',
    img: chxwangImg,
    handle: '@ChxWang',
    text: '"It is cost effective. :)"',
  },
  {
    name: 'Vivek Kanojiya',
    img: vivekImg,
    handle: '@about_vivek',
    text: '"It\'s the least painful insurance experience so far."',
  },
  {
    name: 'Rafayel',
    img: tlepovrafaelImg,
    handle: '@tlepovrafael',
    text: '"It makes adulting feel oddly safe and human."',
  },
  {
    name: 'Yogeesh Seralathan',
    img: yogeesh93Img,
    handle: '@yogeesh93',
    text: '"It makes my insurance anxiety taste like pink clouds."',
  },
  {
    name: 'Jinzhong Hou',
    img: jinzImg,
    handle: '@Jinzhong616',
    text: '"Their secret discounts make dreams come true."',
  },
];
